import React, { useState, useEffect } from 'react';
import {
    Row, Col, Form, FormGroup, Label, Input, Card, CardBody,
    Container, Button, FormFeedback
} from "reactstrap";

import { toast } from "react-toastify";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useNavigate } from "react-router-dom";
import "./CustomCheckbox.css";

const VehicleDocumentsTypesCreate = () => {
    const [title, setTitle] = useState('');
    const [titleArabic, setTitleArabic] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const [validation, setValidation] = useState({
        title: null,
        titleArabic: null,
    });

    const [checkboxes, setCheckboxes] = useState({
        is_upload: false,
        is_required: false,
        is_front_required: false,
        is_back_required: false,
    });

    const handleCheckboxChange = (key) => {
        setCheckboxes((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    const validateFields = () => {
        let isValid = true;
        const newValidation = {};

        newValidation.title = title.trim() !== '';
        newValidation.titleArabic = titleArabic.trim() !== '';

        setValidation(newValidation);

        Object.values(newValidation).forEach(v => {
            if (v !== true) isValid = false;
        });

        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateFields()) return;

        setLoading(true);

        const payload = {
            title,
            title_arabic: titleArabic,
            ...checkboxes,
        };

        try {
            const token = localStorage.getItem("authToken");
            const response = await fetch(`${process.env.REACT_APP_WEB_APP_URL}/api/web/vehicles-documents-types/create`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
                body: JSON.stringify(payload),
            });

            const data = await response.json();

            if (response.status === 200) {
                toast.success('Document type created successfully', { autoClose: 3000 });

                navigate(`/vehicles-documents-types`);
            } else if (response.status === 422) {
                if (data?.errors) {
                    Object.values(data.errors).forEach((errorArr) => {
                        errorArr.forEach((errMsg) => {
                            toast.error(errMsg, { autoClose: 3000 });
                        });
                    });
                } else {
                    toast.error(data?.message || 'Validation failed', { autoClose: 3000 });
                }
            } else {
                toast.error(data?.message || `Error: ${response.statusText}`, { autoClose: 3000 });
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to create type", { autoClose: 3000 });
        } finally {
            setLoading(false);
        }
    };

    document.title = "Add Documents Type (Vehicles) | Moeen";

    return (
        <div className="page-content">
            <Container fluid={true}>
                <Breadcrumbs maintitle="Home" title="Add Documents (Vehicles) Type" />

                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md="6">
                                            {/* Title */}
                                            <div className="mb-3">
                                                <Label>Title</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="Enter title"
                                                    value={title}
                                                    onChange={e => setTitle(e.target.value)}
                                                    valid={validation["title"] === true}
                                                    invalid={validation["title"] !== true && validation["title"] !== null}
                                                />
                                                <FormFeedback tooltip>Title is required.</FormFeedback>
                                            </div>
                                        </Col>

                                        <Col md="6">
                                            {/* Title Arabic */}
                                            <div className="mb-3">
                                                <Label>Title Arabic</Label>
                                                <Input
                                                    type="text"
                                                    placeholder="Enter title arabic"
                                                    value={titleArabic}
                                                    onChange={e => setTitleArabic(e.target.value)}
                                                    valid={validation["titleArabic"] === true}
                                                    invalid={validation["titleArabic"] !== true && validation["titleArabic"] !== null}
                                                />
                                                <FormFeedback tooltip>Title Arabic is required.</FormFeedback>
                                            </div>
                                        </Col>

                                        <Col md="12">
                                            <div className="d-flex flex-wrap gap-2">
                                                {[
                                                    { label: "Is Upload", key: "is_upload" },
                                                    { label: "Is Required", key: "is_required" },
                                                    { label: "Front Required", key: "is_front_required" },
                                                    { label: "Back Required", key: "is_back_required" },
                                                ].map(({ label, key }) => (
                                                    <div
                                                        key={key}
                                                        className={`custom-box-checkbox ${checkboxes[key] ? "active" : ""
                                                            }`}
                                                        onClick={() => handleCheckboxChange(key)}
                                                    >
                                                        {label}
                                                    </div>
                                                ))}
                                            </div>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="text-end">
                                            <Button type="submit" color="primary" disabled={loading}>
                                                {loading ? (
                                                    <>
                                                        <span
                                                            className="spinner-border spinner-border-sm"
                                                            role="status"
                                                            aria-hidden="true"
                                                        ></span>
                                                    </>
                                                ) : (
                                                    "Submit"
                                                )}
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default VehicleDocumentsTypesCreate;
